var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.3125 6.60856H23.125V4.17969H20.75V6.60856H11.25V4.17969H8.875V6.60856H7.6875C6.36937 6.60856 5.32437 7.70155 5.32437 9.03743L5.3125 26.0395C5.3125 27.3754 6.36937 28.4684 7.6875 28.4684H24.3125C25.6187 28.4684 26.6875 27.3754 26.6875 26.0395V9.03743C26.6875 7.70155 25.6187 6.60856 24.3125 6.60856ZM24.3125 26.0395H7.6875V13.8952H24.3125V26.0395ZM12.4375 18.7529H10.0625V16.3241H12.4375V18.7529ZM17.1875 18.7529H14.8125V16.3241H17.1875V18.7529ZM21.9375 18.7529H19.5625V16.3241H21.9375V18.7529ZM12.4375 23.6107H10.0625V21.1818H12.4375V23.6107ZM17.1875 23.6107H14.8125V21.1818H17.1875V23.6107ZM21.9375 23.6107H19.5625V21.1818H21.9375V23.6107Z",
    fill: "#002266"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7e12070be8a8860570166c275693e949.svg";
export { ForwardRef as ReactComponent };